import { render } from "./SendDeal.vue?vue&type=template&id=d6107ef8&scoped=true"
import script from "./SendDeal.vue?vue&type=script&lang=js"
export * from "./SendDeal.vue?vue&type=script&lang=js"

import "./SendDeal.vue?vue&type=style&index=0&id=d6107ef8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6107ef8"]])

export default __exports__